import type { Word, WordProgress } from "./types";

export function selectDueWords(activeWords: Word[], starred: string[], progress: Record<string, WordProgress>, now = Date.now()): Word[] {
  const saved = new Set(starred);
  return activeWords.filter((word) => saved.has(word.id) && (!progress[word.id] || progress[word.id].dueAt <= now));
}

export function findNextReview(activeWords: Word[], starred: string[], progress: Record<string, WordProgress>, now = Date.now()): number | null {
  const activeIds = new Set(activeWords.map((word) => word.id));
  const dates = starred
    .filter((id) => activeIds.has(id))
    .map((id) => progress[id]?.dueAt)
    .filter((date): date is number => typeof date === "number" && date > now);
  return dates.length ? Math.min(...dates) : null;
}
